import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-external-media',
  templateUrl: './add-external-media.component.html',
  styleUrls: ['./add-external-media.component.css']
})
export class AddExternalMediaComponent {
  mediaurl: string = '';
  @ViewChild('youtubediv') youtubediv: ElementRef;
  iframeurl: string;

  constructor(private toastr: ToastrService) { }

  extractVideoUrl(){
    var match = this.mediaurl.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || this.mediaurl.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) {
        return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?rel=0&showinfo=0';
    }
    if (match = this.mediaurl.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
        // eslint-disable-line no-cond-assign
        return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
    }
  }

  urlChanged(){
    // A failed parse must clear the previous result as well as the preview — the caller
    // reads `iframeurl` on Ok, so a stale one inserts the video the user just replaced.
    this.iframeurl = undefined;

    if(!this.mediaurl){
      this.youtubediv.nativeElement.innerHTML = '';
    }
    else{
      this.iframeurl = this.extractVideoUrl();
      if(this.iframeurl){
        this.youtubediv.nativeElement.innerHTML = `<iframe class="ql-video mediaiframe mt-4" frameborder="0" allowfullscreen="true" src="${this.iframeurl}"></iframe>`;
      }
      else{
        this.youtubediv.nativeElement.innerHTML = '';
        this.toastr.error('Unable to parse url. Please, confirm that the url is a valid YouTube or Vimeo url');
      }
    }
  }

  clear(){
    this.mediaurl = ''
    this.urlChanged();
  }

}
